import * as React from 'react';
import VerticalItem, { getItemSize, VerticalItemSize } from './items/VerticalItem';
export default function VisualShoveler(props) {
    var _a, _b, _c, _d;
    const { header, items, seeMoreItem } = props.data;
    if ((_a = items) === null || _a === void 0 ? void 0 : _a.length) {
        const sizes = items.map(item => getItemSize(item));
        const maxSize = sizes.reduce((acc, size) => size > acc ? size : acc, VerticalItemSize.Small);
        return (React.createElement("div", null,
            React.createElement("music-shoveler", { key: header, "see-all": (_b = seeMoreItem) === null || _b === void 0 ? void 0 : _b.text, "primary-text": header, onmusicSeeAllActivate: props.handleSelected.bind(null, (_d = (_c = seeMoreItem) === null || _c === void 0 ? void 0 : _c.primaryLink) === null || _d === void 0 ? void 0 : _d.onItemSelected) }, items.map((item) => (React.createElement(VerticalItem, { data: item, handleSelected: props.handleSelected, parentSize: maxSize }))))));
    }
    return null;
}
;
